import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=9561e696&scoped=true"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=9561e696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9561e696",
  null
  
)

export default component.exports